import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=876108f4&scoped=true&"
import script from "./IssueList.vue?vue&type=script&lang=js&"
export * from "./IssueList.vue?vue&type=script&lang=js&"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=876108f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876108f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('876108f4')) {
      api.createRecord('876108f4', component.options)
    } else {
      api.reload('876108f4', component.options)
    }
    module.hot.accept("./IssueList.vue?vue&type=template&id=876108f4&scoped=true&", function () {
      api.rerender('876108f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Issues/IssueList.vue"
export default component.exports